const SET_CLIENT_INFO_IS_OPEN = 'SET_CLIENT_INFO_IS_OPEN';
const SET_CLIENT_INFO_SELECTED_STATE = 'SET_CLIENT_INFO_SELECTED_STATE';
const SET_CLIENT_INFO_COMPANY_NAME = 'SET_CLIENT_INFO_COMPANY_NAME';
const SET_CLIENT_INFO_STREET = 'SET_CLIENT_INFO_STREET';
const SET_CLIENT_INFO_STREET_2 = 'SET_CLIENT_INFO_STREET_2';
const SET_CLIENT_INFO_IS_LOCKED = 'SET_CLIENT_INFO_IS_LOCKED';
const SET_CLIENT_INFO_ZIP = 'SET_CLIENT_INFO_ZIP';
const SET_CLIENT_INFO_CONTACT_NAME = 'SET_CLIENT_INFO_CONTACT_NAME';
const SET_CLIENT_INFO_PHONE = 'SET_CLIENT_INFO_PHONE';
const SET_CLIENT_INFO_EMAIL = 'SET_CLIENT_INFO_EMAIL';
const SET_CLIENT_INFO_TITLE = 'SET_CLIENT_INFO_TITLE';
const SET_CLIENT_INFO_CITY = 'SET_CLIENT_INFO_CITY';
const CLEAR_CLIENT_INFO = 'CLEAR_CLIENT_INFO';
const SET_COUNTRY = 'SET_COUNTRY';
const SET_CUSTOMER = 'SET_CUSTOMER';
const ERASE_CUSTOMER = 'ERASE_CUSTOMER';


export {
    SET_CLIENT_INFO_SELECTED_STATE,
    SET_CLIENT_INFO_IS_OPEN,
    SET_CLIENT_INFO_COMPANY_NAME,
    SET_CLIENT_INFO_STREET,
    SET_CLIENT_INFO_STREET_2,
    SET_CLIENT_INFO_IS_LOCKED,
    SET_CLIENT_INFO_ZIP,
    SET_CLIENT_INFO_CONTACT_NAME,
    SET_CLIENT_INFO_PHONE,
    SET_CLIENT_INFO_EMAIL,
    SET_CLIENT_INFO_TITLE,
    SET_CLIENT_INFO_CITY,
    CLEAR_CLIENT_INFO,
    SET_COUNTRY,
    SET_CUSTOMER,
    ERASE_CUSTOMER,
};



// WEBPACK FOOTER //
// ./src/containers/AddClient/ClientInfo/constants.js